import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { AffiliateSchema, AffiliateReadSchema, AddressSchema, BankingInfoSchema, SocialMediaSchema, OrganizationSchema } from "model/_base/affiliates";

// Yup Schemas
export const PartnerInfoSchema = AffiliateReadSchema.clone()
  .transform(transformSnakeToCamel)
  .concat(Yup.object().transform(transformSnakeToCamel))
  .shape({
    addresses: Yup.array().of(AddressSchema.default(undefined)).default([]),
    bankAccounts: Yup.array().of(BankingInfoSchema.default(undefined)).default([]),
    socialMedia: Yup.array().of(SocialMediaSchema.default(undefined)).default([]),
    // organization: OrganizationSchema.nullable(),
  });

export default class PartnerInfoModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      console.log(json.data);
      const model = PartnerInfoSchema.cast(json.data, {
        abortEarly: false,
        stripUnknown: true,
      });
      console.log(model);
      return model;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    try {
      return transformModelToJson(model);
    } catch (error) {
      console.error("Error transforming PartnerInfo model to JSON:", error);
      return null;
    }
  }
}
